// import "../store/auth.js";
import router from "./router.js";
import ACLService from "../services/ACLService";
import Cookies from "js-cookie";
import axios from "axios";
// import { setProfile } from "../api";
// import { setIv } from "../api";
// import mutations from "@/store/mutations";

/* eslint-disable */
export default {
  // auth({ store, next, to }) {
  // register({ store, next }) {
  register({ store }) {
    router.beforeEach((to, from, next) => {
      const token = Cookies.get("token_hrd");
      if (to.matched.some(record => record.meta.requireAuth)) {
        if (token === null || token === undefined) {
          next("/login");
        } else {
          next();
        }
      } else if (to.matched.some(record => record.meta.guest)) {
        if (token === null || token === undefined) {
          next();
        } else {
          next("/dashboard");
        }
      }
    });
    router.afterEach(async (to, from) => {
      const temp_user = JSON.parse(Cookies.get("userdata_login"));
      store.commit("system/SET_IDMENU", temp_user.data.user_type_id);
      const token = Cookies.get("token");
      axios.defaults.headers.common['profile_id'] = token;

      if (to.meta.requireAuth === true) {
        await store.dispatch('system/getMenus').then(res => {
          if (res.status === 200) {
            store.commit("system/SET_USERROLE", res.data.data);
            const permissions = store.getters['permissions'];
            const acl = new ACLService(permissions);
            const hasPermissions = acl.checkRoutePermissions(to);
            if (!hasPermissions) {
              router.push("/dashboard");
            }
          } else if (res.status === 401) {
            Cookies.remove("token");
            Cookies.remove("data_user");
            router.push({
              path: '/login',
              params: {
                error: 401
              }
            });
          }
        });
      }
    });
  }
}